import * as React from 'react';
import { safe, toDisplay, isNullOrUndefined, addItemToGoogleTracking } from "../../utils";
import { IPageProperties } from "../../models";
import * as moment from "moment";
import { NumberFormat } from "../../assets/NumberFormat/NumberFormat";
import { Tooltip } from "../../assets/Tooltip/Tooltip";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { ArrowIndicator, Disclaimer } from "../../assets";
import { getCurrencySymbol } from '../../utils/currency';

const overrideStyles = require('./overrides/tooltipOverrides.pcss');
const FaAngleDown = require('react-icons/lib/fa/angle-down');
const FaPlus = require('react-icons/lib/fa/plus');
const FaMinus = require('react-icons/lib/fa/minus');
const styles = require('./styles.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');
const toolTipstyles = require('./overrides/tooltipOverrides.pcss');
const FaStarO = require('react-icons/lib/fa/star-o');
const FaStar = require('react-icons/lib/fa/star');

interface IState {
    visible: boolean;
}

export class PageOverview extends React.Component<IPageProperties, IState>{
    constructor(props) {
        super(props);

        this.state = { visible: false };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        let { shareClass, appParams } = this.props;
        let visible = !this.state.visible;
        addItemToGoogleTracking(appParams, "fund_page_objective_policy", { eventCategory: shareClass.clientCode, eventLabel: visible ? 'read more' : 'read less' });
        this.setState({ visible });
    }

    getToolTip(tooltipData) {
        if (!isNullOrUndefined(tooltipData) && !tooltipData.is_deleted) {
            return (
                <Tooltip
                    styles={toolTipstyles}
                    text={tooltipData.disclaimer}>
                </Tooltip>
            );
        }
    }

    getPrice(assetClass, navSharePriceCheck) {
        let { shareClass, disclaimers } = this.props;
        let currencySymbol = safe(() => getCurrencySymbol(shareClass.properties.currency), { isMajor: false, value: "" });
        if (assetClass === "Property") {
            let values = ['bid_price', 'offer_price'];
            return values.map((item, index) => (
                <div key={index} className={styles.item + ' ' + styles.option1}>
                    <p>
                        <span className={styles.itemText}>{toDisplay(item)}&nbsp;
                            {this.getToolTip(safe(() => disclaimers[`tooltip_${item}`][0]["disclaimers"][0], null))}
                            <br />({safe(() => moment(shareClass.latestTimeseriesValues['prices']['date']).format('DD.MM.YYYY'), null)})
                        </span>
                        <span className={styles.itemValue}>
                            {currencySymbol.isMajor ? `${currencySymbol.value} ` : ""}
                            <NumberFormat>{safe(() => shareClass.latestTimeseriesValues['prices'][`local_${item}`], null)}</NumberFormat>
                            {currencySymbol.isMajor ? "" : `${currencySymbol.value} `}
                        </span>
                    </p>
                </div>

            ));
        } else {
            if (navSharePriceCheck === 'SharePrice'){
                return (
                    <div className={styles.item + ' ' + styles.option1}>
                        <p>
                            <span className={styles.itemText}>Share Price ({safe(() => moment(shareClass.latestTimeseriesValues['share_prices']['date']).format('DD.MM.YYYY'), null)})&nbsp;
                                {this.getToolTip(safe(() => disclaimers[`tooltip_price`][0]["disclaimers"][0], null))}
                            </span>
                            <span className={styles.itemValue}>
                                {currencySymbol.isMajor ? `${currencySymbol.value} ` : ""}
                                <NumberFormat>{safe(() => shareClass.latestTimeseriesValues['share_prices']['shareclass_price'], null)}</NumberFormat>
                                {currencySymbol.isMajor ? "" : `${currencySymbol.value} `}
                            </span>
                        </p>
                    </div>
                );
            } else if (navSharePriceCheck === 'navPrice') {
                return (
                    <div className={styles.item + ' ' + styles.option1}>
                        <p>
                            <span className={styles.itemText}>NAV ({safe(() => moment(shareClass.latestTimeseriesValues['nav_prices']['date']).format('DD.MM.YYYY'), null)})&nbsp;
                                {this.getToolTip(safe(() => disclaimers[`tooltip_nav`][0]["disclaimers"][0], null))}
                            </span>
                            <span className={styles.itemValue}>
                                {currencySymbol.isMajor ? `${currencySymbol.value} ` : ""}
                                <NumberFormat>{safe(() => shareClass.latestTimeseriesValues['nav_prices']['value'], null)}</NumberFormat>
                                {currencySymbol.isMajor ? "" : `${currencySymbol.value} `}
                            </span>
                        </p>
                    </div>
                );
            } else {
                return (
                    <div className={styles.item + ' ' + styles.option1}>
                        <p>
                            <span className={styles.itemText}>Price ({safe(() => moment(shareClass.latestTimeseriesValues['prices']['date']).format('DD.MM.YYYY'), null)})&nbsp;
                                {this.getToolTip(safe(() => disclaimers[`tooltip_price`][0]["disclaimers"][0], null))}
                            </span>
                            <span className={styles.itemValue}>
                                {currencySymbol.isMajor ? `${currencySymbol.value} ` : ""}
                                <NumberFormat>{safe(() => shareClass.latestTimeseriesValues['prices']['shareclass_price'], null)}</NumberFormat>
                                {currencySymbol.isMajor ? "" : `${currencySymbol.value} `}
                            </span>
                        </p>
                    </div>
                );
            }
        }
    }

    getInvestmentObjective(internalClasses) {
        let { visible } = this.state;
        let { fund } = this.props;
        let objectivePolicyData = safe(() => fund.statistics.filter(item => item.code === "investment_objective").shift().values, []);

        if (objectivePolicyData.length === 0) {
            return (
                <div className={styles.bodyRow}>
                    <p className={styles.bodyText}><i>There is no objective defined in the database for this shareclass</i></p>
                </div>
            );
        } else {
            let [objective] = safe(() => objectivePolicyData.filter(item => (item["type"] as string).toLowerCase() === "objective"), { text: "" });
            let [policy] = safe(() => objectivePolicyData.filter(item => (item["type"] as string).toLowerCase() === "policy"), { text: "" });
            let [benchmark] = safe(() => objectivePolicyData.filter(item => (item["type"] as string).toLowerCase() === "benchmarkdisclaimer"), { text: "" });

            let policyArray = (policy["text"] as string).split(" ");
            let policyIntro = policyArray.slice(0, 16).join(" ");
            let policyAll = policyArray.join(" ").split("\r\n");

            if (benchmark) {
                policyAll.push(benchmark["text"] as string);
            }
            let regex = /h[1-6]/g;
            let objectiveText = { __html: (objective["text"] as string).replace(regex, "h4") };
            let introHTML = { __html: `${policyIntro.replace(regex, "h4")}...` };
            let allHTML = { __html: `${policyAll.join("").replace(regex, "h4")}` };

            return (
                <div className={styles.bodyRow}>
                    <h2 className={styles.title}>{objectivePolicyData[0].heading}</h2>
                    <div className={styles.bodyText} dangerouslySetInnerHTML={objectiveText}></div>
                    {(() => {
                        if (!visible) {
                            return (<div className={styles.bodyText} dangerouslySetInnerHTML={introHTML}></div>);
                        }
                    })()}
                    <div className={styles.bodyText}>
                        <div className={internalClasses.dropdown} dangerouslySetInnerHTML={allHTML}></div>
                    </div>
                </div>
            );
        }
    }

    getYieldBlock(disclaimers, suffixOptions, shareClass) {
        let yieldValue = safe(() => shareClass.latestTimeseriesValues['prices']['yield'], 0);
        if (!yieldValue) {
            return;
        }
        let shareClassProperties = safe(() => shareClass.properties, {})

        // Added regulatory check to hide yield for shareclasses
        let regulatoryFunds = ["DIV","EXYD","GLOD","CHAR"];

        if (regulatoryFunds.indexOf(shareClassProperties['fund_key']) === -1){
            return (
                <div className={styles.item + ' ' + styles.option3}>
                    <p>
                        <span className={styles.itemText}>Yield&nbsp;
                            {this.getToolTip(safe(() => disclaimers[`tooltip_yield`][0]["disclaimers"][0], null))}
                        </span>
                        <span className={styles.itemValue}><NumberFormat options={Object.assign({}, suffixOptions, { precision: 1 })}>{yieldValue}</NumberFormat></span>
                    </p>
                </div>
            );
        }
    }

    getNavPrice(){
        let { shareClass, fund, disclaimers } = this.props;
        let suffixOptions = {
            suffix: '%',
            emptyValue: '0.00%'
        };
        let absolutePriceChange = safe(() => shareClass.latestTimeseriesValues['nav_prices']['nav_absolute_price_change'], null);
        let clientCode = fund.clientCode;
        let clientCodeList = ['CIIT'];
        let clientTypes = shareClass.properties.client_types;
        let clientTypesList = ['Discretionary Wealth', 'End Investor', 'Independent Financial Advisor'];
        let clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1)
        
        if (clientCodeList.indexOf(clientCode) > -1 && clientTypeCheck) {
            return (
                <div className={styles.headerRow}>
                {this.getPrice(fund.properties["asset_class"], 'navPrice')}
                    <div className={styles.item + ' ' + styles.option2}>
                        <p>
                            <span className={styles.itemText}>Change&nbsp;
                                {this.getToolTip(safe(() => disclaimers[`tooltip_nav_change`][0]["disclaimers"][0], null))}
                            </span>
                            <span className={styles.itemValue}>
                                {(() => {
                                    if (absolutePriceChange) {
                                        return (
                                            <span>
                                                <NumberFormat options={{ emptyValue: "0.00" }}>{absolutePriceChange}</NumberFormat>
                                                <span className="itemValueseparator"> / </span>
                                            </span>
                                        )
                                    }
                                })()}             
                                <NumberFormat options={suffixOptions}>{safe(() => shareClass.latestTimeseriesValues['nav_prices']['percentage_price_change'], null)}</NumberFormat>
                                <ArrowIndicator showValueWithArrow={false} value={safe(() => shareClass.latestTimeseriesValues['nav_prices']['absolute_price_change'], null)}></ArrowIndicator>
                            </span>
                        </p>
                    </div>
            </div>
            );
        }
    }

    render() {
        let { isLoading, shareClass, fund, appParams, disclaimers, watchlist } = this.props;
        if (this.props.isLoading || !fund) {
            return null;
        }

        let isPrivateInvestor = appParams.clienttype === "pri";
        let shareClassProperties = safe(() => shareClass.properties, {});
        let visibility = !this.state.visible ? '' : styles.active;
        let suffixOptions = {
            suffix: '%',
            emptyValue: '0.00%'
        };
        let showValueWithArrow = true;

        let internalClasses = {
            caret: `${styles.caret} ${visibility}`,
            dropdown: `${styles.bodyTextHidden} ${visibility}`,
            elipsis: `${styles.elipsis} ${visibility}`,
            readMore: `${styles.readMore} ${visibility}`,
            readMoreBtn: `${styles.readMoreBtn} ${visibility}`
        }
        let absolutePriceChange = safe(() => shareClass.latestTimeseriesValues['prices']['absolute_price_change'], null);

        let sharePriceData = safe(() => shareClass.latestTimeseriesValues['share_prices']);
        let navSharePriceData = safe(() => shareClass.latestTimeseriesValues['nav_prices']);

        let clientCode = fund.clientCode;
        let clientCodeList = ['CIIT'];
        let clientTypes = shareClass.properties.client_types;
        let clientTypesList = ['Discretionary Wealth', 'End Investor', 'Independent Financial Advisor'];
        let clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1)
        
        return (
            <div className={styles.wrapper}>
            {(() => {
                if (!isNullOrUndefined(sharePriceData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck){
                    return (
                        <div>
                            <div className={styles.headerRow}>
                            {this.getPrice(fund.properties["asset_class"], 'SharePrice')}
                                <div className={styles.item + ' ' + styles.option2}>
                                    <p>
                                        <span className={styles.itemText}>Change&nbsp;
                                            {this.getToolTip(safe(() => disclaimers[`tooltip_change_%`][0]["disclaimers"][0], null))}
                                        </span>
                                        <span className={styles.itemValue}>
                                            {(() => {
                                                if (absolutePriceChange) {
                                                    return (
                                                        <span>
                                                            <NumberFormat options={{ emptyValue: "0.00" }}>{absolutePriceChange}</NumberFormat>
                                                            <span className="itemValueseparator"> / </span>
                                                        </span>
                                                    )
                                                }
                                            })()}                        
                                            <NumberFormat options={suffixOptions}>{safe(() => shareClass.latestTimeseriesValues['share_prices']['percentage_price_change'], null)}</NumberFormat>
                                            <ArrowIndicator showValueWithArrow={false} value={safe(() => shareClass.latestTimeseriesValues['share_prices']['value'], null)}></ArrowIndicator>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            { (!isNullOrUndefined(navSharePriceData)) ? <div>{this.getNavPrice()}</div> : '' }
                        </div>
                    );
                } else {
                    return (
                        <div className={styles.headerRow}>
                            {this.getPrice(fund.properties["asset_class"], false)}
                            <div className={styles.item + ' ' + styles.option2}>
                                <p>
                                    <span className={styles.itemText}>Change&nbsp;
                                        {this.getToolTip(safe(() => disclaimers[`tooltip_change_%`][0]["disclaimers"][0], null))}
                                    </span>
                                    <span className={styles.itemValue}>
                                        {(() => {
                                            if (absolutePriceChange) {
                                                return (
                                                    <span>
                                                        <NumberFormat options={{ emptyValue: "0.00" }}>{absolutePriceChange}</NumberFormat>
                                                        <span className="itemValueseparator"> / </span>
                                                    </span>
                                                )
                                            }
                                        })()}                        
                                        <NumberFormat options={suffixOptions}>{safe(() => shareClass.latestTimeseriesValues['prices']['percentage_price_change'], null)}</NumberFormat>
                                        <ArrowIndicator showValueWithArrow={false} value={safe(() => shareClass.latestTimeseriesValues['prices']['absolute_price_change'], null)}></ArrowIndicator>
                                    </span>
                                </p>
                            </div>
                            {this.getYieldBlock(disclaimers, suffixOptions, shareClass)}
                        </div>
                    );
                }
            })()}
                {this.getInvestmentObjective(internalClasses)}
                <div onClick={this.toggle} className={internalClasses.readMore}>
                    <button type="button" className={internalClasses.readMoreBtn}> <div className={internalClasses.caret}><FaAngleDown /></div></button>
                </div>
                {(() => {
                    if (!isNullOrUndefined(shareClass.disclaimers["shareclass_fundobjectivepolicy"]) && !shareClass.disclaimers["shareclass_fundobjectivepolicy"][0].is_deleted) {
                        return (
                            <div className={styles.disclaimer}>
                                <Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_fundobjectivepolicy"]}></Disclaimer>
                            </div>
                        );
                    }
                })()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/components/PageOverview/index.tsx